import { SelectButtonItem } from 'src/components/choose-button/choose-button';
import { i18n } from 'src/i18n';
import { ServiceType } from 'src/model/service-type';
import {
  cellTowerImageProps,
  gamingImageProps,
  phoneImageProps,
  tvImageProps,
  wifiImageProps,
} from 'src/resources/images';

export class ServiceTypeMapper {
  public static toSelectButtonItem = (serviceType: string): SelectButtonItem => {
    switch (serviceType) {
      case ServiceType.TV:
        return {
          text: i18n.page.chooseServiceLocation.serviceType.tv,
          icon: tvImageProps,
        };
      case ServiceType.INTERNET:
        return {
          text: i18n.page.chooseServiceLocation.serviceType.wifi,
          icon: wifiImageProps,
        };
      case ServiceType.VOIP:
        return {
          text: i18n.page.chooseServiceLocation.serviceType.phone,
          icon: phoneImageProps,
        };
      case ServiceType.XBOX_ALL_ACCESS:
        return {
          text: i18n.page.chooseServiceLocation.serviceType.gaming,
          icon: gamingImageProps,
        };
      case ServiceType.FWA:
        return {
          text: i18n.page.chooseServiceLocation.serviceType.fixedWirelessAccess,
          icon: cellTowerImageProps,
        };
      default:
        return {
          text: serviceType,
          icon: tvImageProps,
        };
    }
  };
}
